import { useSelector } from 'react-redux';
import { currentUserSelector } from '@modules/current-user/selectors/auth';
import { EMPTY_STRING, NOT_ENTERED } from '@common/constants';

export const useUserInfo = () => {
  const { Name, Phone } = useSelector(currentUserSelector);

  return { userName: Name || EMPTY_STRING, userPhone: Phone || NOT_ENTERED };
};
